import '../../style';
import './index.less';



// WEBPACK FOOTER //
// ./components/rating/style/index.tsx